import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FacturacionRoutingModule } from './facturacion-routing.module';
import { CrearFacturaManualComponent } from './pages/crear-factura-manual/crear-factura-manual.component';
import { FormCabeceraComponent } from './components/form-cabecera/form-cabecera.component';
import { FormEmisorComponent } from './components/form-emisor/form-emisor.component';
import { FormReceptorComponent } from './components/form-receptor/form-receptor.component';
import { FormConceptosComponent } from './components/form-conceptos/form-conceptos.component';
import { NgbCollapseModule, NgbToastModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Select2Module } from 'ng-select2-component';
import { ModalAgregarConceptoComponent } from './components/modal-agregar-concepto/modal-agregar-concepto.component';
import { CustomToasterComponent } from './components/custom-toaster/custom-toaster.component';
import { FormImpuestosConceptosComponent } from './components/form-impuestos-conceptos/form-impuestos-conceptos.component';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
  declarations: [
    CrearFacturaManualComponent,
    FormCabeceraComponent,
    FormEmisorComponent,
    FormReceptorComponent,
    FormConceptosComponent,
    ModalAgregarConceptoComponent,
    CustomToasterComponent,
    FormImpuestosConceptosComponent
    
  ],
  imports: [
    CommonModule,
    FacturacionRoutingModule,
    NgbCollapseModule,
    ReactiveFormsModule,
    FormsModule,
    Select2Module,
    NgbTooltipModule,
    NgbToastModule,
    SharedModule

  ],
  exports: [
    FormEmisorComponent,
    FormReceptorComponent,
    FormConceptosComponent,
    FormCabeceraComponent,
    CustomToasterComponent,
    CrearFacturaManualComponent
  ]
})
export class FacturacionModule { }
